{
  "consentModal": {
    "label": "Cookievoorkeuren",
    "title": "Cookies op Ondia",
    "description": "We gebruiken cookies om je ervaring te verbeteren en ons websiteverkeer te analyseren. <a href=\"https://www.ondia.be/privacy\" target=\"_blank\" rel=\"noopener\">Lees ons cookiebeleid</a>{{revisionMessage}}",
    "acceptAllBtn": "Alles toestaan",
    "acceptNecessaryBtn": "Alleen noodzakelijke",
    "showPreferencesBtn": "Voorkeuren beheren",
    "revisionMessage": "<br>We hebben ons cookiebeleid aangepast sinds je laatste keuze. Bekijk je voorkeuren opnieuw."
  },
  "preferencesModal": {
    "title": "Cookievoorkeuren",
    "acceptAllBtn": "Alles toestaan",
    "acceptNecessaryBtn": "Alleen noodzakelijke",
    "savePreferencesBtn": "Keuze opslaan",
    "closeIconLabel": "Sluiten",
    "serviceCounterLabel": "dienst|diensten",
    "sections": [
      {
        "description": "We gebruiken cookies om de basisfunctionaliteit van de website te garanderen en om je online ervaring te verbeteren."
      },
      {
        "title": "Noodzakelijke cookies",
        "description": "Deze cookies zijn essentieel voor het goed functioneren van de website en kunnen niet worden uitgeschakeld.",
        "linkedCategory": "necessary"
      },
      {
        "title": "Statistieken",
        "description": "Deze cookies helpen ons te begrijpen hoe bezoekers de website gebruiken, zodat we deze kunnen verbeteren.",
        "linkedCategory": "analytics"
      },
      {
        "title": "Marketing",
        "description": "Deze cookies worden gebruikt om relevante advertenties en marketingcampagnes aan te bieden.",
        "linkedCategory": "marketing"
      }
    ]
  },
  "cookieTableCaption": "Cookies in deze categorie",
  "cookieTableHeaders": {
    "name": "Cookie",
    "provider": "Aanbieder",
    "purpose": "Doel",
    "duration": "Bewaartermijn"
  },
  "cookiePurposes": {
    "consent": "Bewaart je cookiekeuze voor alle Ondia-sites.",
    "botDetection": "Onderscheidt bezoekers van geautomatiseerd verkeer.",
    "formState": "Onthoudt de status van een formulier tijdens het invullen.",
    "authSession": "Houdt je ingelogd tijdens je sessie.",
    "csrf": "Beveiligt formulieren tegen misbruik van buitenaf.",
    "gaClientId": "Onderscheidt bezoekers voor bezoekersstatistieken.",
    "gaSessionState": "Houdt de status van je bezoek bij.",
    "productAnalytics": "Meet welke functies in het platform gebruikt worden.",
    "adConversion": "Meet of een advertentie tot een aanvraag heeft geleid.",
    "linkedinId": "Herkent je browser op LinkedIn en op onze site.",
    "linkedinMatch": "Koppelt je bezoek aan een LinkedIn-doelgroep.",
    "chatSession": "Houdt een lopend chatgesprek bij."
  },
  "durations": {
    "session": "Sessie",
    "m30": "30 minuten",
    "d90": "90 dagen",
    "y1": "1 jaar",
    "y2": "2 jaar"
  }
}
